import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Loading from '../../components/Loading';

const DemoRedirect = () => {
  const { loginAsDemoUser, demoEpicPatientId, isDemoSession, isLoading, demoEpicOrgId } = useAuth();
  const [ load, setLoad ] = useState(false);

  useEffect(() => {
    const init = async () => {
      const success = await loginAsDemoUser();
      if (!success) {
        window.location.href = '/error';
      }
      setLoad(true)
    }

    init();
  }, [loginAsDemoUser]);

  useEffect(() => {
    if (!isDemoSession || isLoading || !load) return;
    window.location.href = `/${demoEpicOrgId}/dashboard/${demoEpicPatientId}`;
  }, [demoEpicPatientId, isDemoSession, isLoading, demoEpicOrgId, load ]);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="bg-white shadow-xl rounded-2xl p-10 max-w-md w-full space-y-6 text-center">
        <Loading message="Setting up Demo Environment..." />
      </div>
    </div>
  );
};

export default DemoRedirect;
